// extracted by mini-css-extract-plugin
module.exports = {"container":"LabelPhone_container__2XfXO","prefix":"LabelPhone_prefix__3a7S4","number":"LabelPhone_number__1ElN-"};